import gql from 'graphql-tag';
// import { AssetImageSubtype } from 'src/modules/assets';
import { FRAGMENT_FULL_HERO } from 'src/modules/layout/components/block/fullHero/queries';
import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
import { FRAGMENT_CTA_BUTTON } from 'src/modules/global/components/cta/queries';

export const QUERY_IMAGE_COMPONENT = gql`
  fragment imageComponent on ComponentMediaImage {
    image {
      alternativeText
      width
      height
      url
      previewUrl
    }
    caption_en
    caption_de
    products(sort: "name_en:asc") {
      slug
      name_en
      name_de
      product_categories(sort: "ranking:asc", limit: 1) {
        slug
      }
    }
  }
`;

// NOTE: I'm creating aliases for the channel field (ex:
// text_image_card_channel) to prevent GraphQL errors
export const FRAGMENT_DYNAMIC_ZONES = gql`
  fragment dynamicZone on ProductSeriesDynamicContentDynamicZone {
    __typename
    ... on ComponentTextImageCard {
      text_image_card_channel: channel
      id
      link
      image {
        url
      }
      title_en
      title_de
      body_text_en
      body_text_de
    }
    __typename
    ... on ComponentTextImageCardsDownloadsLayout {
      id
      title_cards_downloads_en: title_en
      title_cards_downloads_de: title_de
      cards {
        id
        cta_1 {
          ...ctaButton
        }
        cta_2 {
          ...ctaButton
        }
        image_en {
          url
          width
          height
        }
        image_de {
          url
          width
          height
        }
        text_image_card_download_channel: channel
        copy_en
        copy_de
        title_en
        title_de
      }
    }
    __typename
    ... on ComponentTextImageTextAndImage {
      id
      text_and_image_channel: channel
      title_En: title_en
      title_De: title_de
      label_en
      subline_en
      label_de
      subline_de
      image_position
      image {
        image {
          url
          caption
        }
        caption_en
        caption_de
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
      button {
        text_en
        text_de
        url
        external_link
        isButton: button
        overlay
        download {
          url
        }
      }
    }
    __typename
    ... on ComponentTextImageHero {
      ...hero
      hero_channel: channel
    }
    __typename
    ... on ComponentTextImageFullWidthHero {
      ...fullHero
      full_width_hero_channel: channel
    }
    __typename
    ... on ComponentTextImageMultiImageLayout {
      multi_image_layout_channel: channel
      id
      title_En: title_en
      title_De: title_de
      body_text_en
      body_text_de
      body_text_secondary_en
      body_text_secondary_de
      image1 {
        caption_en
        caption_de
        image {
          url
        }
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
      image2 {
        caption_en
        caption_de
        image {
          url
        }
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
      image3 {
        caption_en
        caption_de
        image {
          url
        }
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
      button {
        text_en
        text_de
        url
        external_link
        isButton: button
        overlay
        download {
          url
        }
      }
    }
    __typename
    ... on ComponentTextQuote {
      text_quote_channel: channel
      quote_en
      quote_de
      author_name
    }
    __typename
    ... on ComponentTextTextBlock {
      text_block_channel: channel
      body_text_en
      body_text_de
      button {
        text_en
        text_de
        url
        external_link
        isButton: button
        overlay
        download {
          url
        }
      }
    }
    __typename
    ... on ComponentMediaVideo {
      media_video_channel: channel
      video {
        url
        ext
        mime
        caption
      }
      cover {
        url
      }
      caption_en
      caption_de
    }

    __typename
    ... on ComponentMediaSideBySideImages {
      media_side_by_side_images_channel: channel
      image1 {
        caption_en
        caption_de
        image {
          url
          width
          height
        }
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
      image2 {
        caption_en
        caption_de
        image {
          url
          width
          height
        }
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
    }

    __typename
    ... on ComponentMediaImage {
      ...imageComponent
      media_image_channel: channel
      # products {
      #   slug
      #   name_en
      #   name_de
      #   product_categories(sort: "ranking:asc", limit: 1) {
      #     slug
      #   }
      # }
    }
    __typename
    ... on ComponentMediaGallery {
      media_gallery_channel: channel
      images {
        image {
          id
          alternativeText
          url
          formats
          caption
          width
          height
        }
        caption_en
        caption_de
        products {
          slug
          name_en
          name_de
          product_categories(sort: "ranking:asc", limit: 1) {
            slug
          }
        }
      }
    }
    __typename
    ... on ComponentCtaButton {
      ...ctaButton
      cta_button_channel: channel
    }
    __typename
    ... on ComponentMediaProductInContext {
      product_in_context_channel: channel
      image {
        alternativeText
        url
        height
        width
        caption
      }
      products {
        x
        y
        product {
          name_en
          name_de
          slug
          product_categories {
            id
            slug
          }
          assets(where: { subtype: "picture.pdp-cutout." }, sort: "sorting:asc", limit: 1) {
            subtype
            file {
              url
              alternativeText
              width
              height
            }
          }
          product_series {
            designer {
              id
              name
            }
          }
        }
      }
    }
  }
  ${QUERY_IMAGE_COMPONENT}
  ${FRAGMENT_HERO}
  ${FRAGMENT_FULL_HERO}
  ${FRAGMENT_CTA_BUTTON}
`;
